// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ov-summ-card[data-v-b19fc706] {\n  /* border: 2px solid red; */\n  width: -moz-fit-content;\n  width: fit-content;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\n@media screen and (max-width: 890px) {\n.ov-summ-card[data-v-b19fc706] {\n    width: 45%;\n}\n}\n@media screen and (max-width: 750px) {\n.ov-summ-card[data-v-b19fc706] {\n    width: 100%;\n}\n}\n", ""]);
// Exports
module.exports = exports;
